import React from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Checkbox,
  Typography,
  Space,
} from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  FacebookOutlined,
  LinkedinOutlined,
  TwitterOutlined,
} from "@ant-design/icons";
import { CiYoutube } from "react-icons/ci";
import "antd/dist/reset.css";

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;

const ContactUs = () => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log("Form values:", values);
    // Here you would typically send the data to your backend
    form.resetFields();
  };

  const contactInfo = [
    // {
    //   icon: <EnvironmentOutlined style={{ fontSize: '24px', marginBottom: '8px' }} />,
    //   title: "Visit us",
    //   content: (
    //     <a
    //       href="https://www.google.com/maps/place/67+Wisteria+Way,+Croydon+South+VIC+3136+AU"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       className="montioner"
    //     >
    //       67 Wisteria Way<br />Croydon South VIC 3136 AU
    //     </a>
    //   )
    // },
    {
      icon: <MailOutlined style={{ fontSize: "24px", marginBottom: "8px" }} />,
      title: "Chat to us",
      content: (
        <a
          className="montioner"
          href="mailto:admin@sethwhiteproductions.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          admin@sethwhiteproductions.com
        </a>
      ),
    },
    {
      icon: <PhoneOutlined style={{ fontSize: "24px", marginBottom: "8px" }} />,
      title: "Call us",
      content: (
        <a
          className="montioner"
          href="tel:+2817779262"
          target="_blank"
          rel="noopener noreferrer"
        >
          281-777-9262
        </a>
      ),
    },
  ];

  const socialLinks = [
    {
      icon: <CiYoutube />,
      name: "YouTube",
      url: "https://youtube.com/@sethwhiteproductions?si=YpPoqssV4w3G-Z2G",
    },
    // { icon: <LinkedinOutlined />, name: "LinkedIn", url: "#" },
    // { icon: <TwitterOutlined />, name: "Twitter", url: "#" },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#0a0a0a",
        display: "flex",
        alignItems: "center",
      }}
      className="contactPadding"
    >
      <Row
        gutter={[48, 24]}
        justify="center"
        style={{ width: "100%", maxWidth: "1400px", margin: "0 auto" }}
      >
        {/* Left Column - Contact Info */}
        <Col xs={24} md={10}>
          <div
            style={{
              background:
                "linear-gradient(145deg, rgb(241 171 0 / 70%) 0%, rgb(245 230 195) 100%)",

              borderRadius: "24px",
              color: "#ffffff",
              height: "100%",
              minHeight: "600px",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 20px 40px rgba(37, 99, 235, 0.2)",
            }}
            className="contactpadding"
          >
            <Title
              level={2}
              className="mention-font"
              style={{
                color: "#ffffff",
                marginBottom: "2.5rem",
                fontWeight: "600",
                fontSize: "2rem",
              }}
            >
              Get in touch
            </Title>

            <Space direction="vertical" size="large" style={{ flex: 1 }}>
              {contactInfo.map((info, index) => (
                <div key={index}>
                  {info.icon}
                  <Title
                    level={4}
                    className="mention-font1"
                    style={{ color: "#ffffff", margin: "0 0 4px 0" }}
                  >
                    {info.title}
                  </Title>
                  <Paragraph
                    style={{
                      color: "#ffffff",
                      margin: 0,
                      whiteSpace: "pre-line",
                      opacity: 0.9,
                    }}
                  >
                    {info.content}
                  </Paragraph>
                </div>
              ))}

              <div style={{ marginTop: "auto" }}>
                <Title
                  level={4}
                  style={{ color: "#ffffff", marginBottom: "1rem" }}
                >
                  Social Media
                </Title>
                <Space size="middle">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.url}
                      style={{
                        color: "#ffffff",
                        fontSize: "24px",
                        transition: "opacity 0.3s",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.opacity = "0.8")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.opacity = "1")
                      }
                    >
                      {social.icon}
                      <span style={{ fontSize: "16px" }}>{social.name}</span>
                    </a>
                  ))}
                </Space>
              </div>
            </Space>
          </div>
        </Col>

        {/* Right Column - Contact Form */}
        <Col xs={24} md={12}>
          <div
            style={{
              backgroundColor: "#1a1a1a",

              borderRadius: "24px",
              border: "1px solid #333333",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
            }}
            className="contactpadding"
          >
            <Title
              level={2}
              className="mention-font1"
              style={{
                color: "#ffffff",
                marginBottom: "2rem",
                fontSize: "1.75rem",
              }}
            >
              Send us a message
            </Title>

            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              size="large"
            >
              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="firstName"
                    label={
                      <span
                        className="mention-font"
                        style={{ color: "#ffffff" }}
                      >
                        First Name
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please enter your first name",
                      },
                    ]}
                  >
                    <Input
                      className="mention-font"
                      placeholder="John"
                      style={{
                        backgroundColor: "#262626",
                        borderColor: "#404040",
                        color: "#ffffff",
                        borderRadius: "8px",
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="lastName"
                    label={
                      <span
                        className="mention-font"
                        style={{ color: "#ffffff" }}
                      >
                        Last Name
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please enter your last name",
                      },
                    ]}
                  >
                    <Input
                      className="mention-font"
                      placeholder="Doe"
                      style={{
                        backgroundColor: "#262626",
                        borderColor: "#404040",
                        color: "#ffffff",
                        borderRadius: "8px",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                name="company"
                label={
                  <span className="mention-font" style={{ color: "#ffffff" }}>
                    Company Name
                  </span>
                }
                rules={[
                  { required: true, message: "Please enter your company name" },
                ]}
              >
                <Input
                  className="mention-font"
                  placeholder="Paysphere Inc."
                  style={{
                    backgroundColor: "#262626",
                    borderColor: "#404040",
                    color: "#ffffff",
                    borderRadius: "8px",
                  }}
                />
              </Form.Item>

              <Form.Item
                className="mention-font"
                name="email"
                label={
                  <span className="mention-font" style={{ color: "#ffffff" }}>
                    Email
                  </span>
                }
                rules={[
                  { required: true, message: "Please enter your email" },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input
                  className="mention-font"
                  placeholder="john.doe@company.com"
                  prefix={<MailOutlined style={{ color: "#e6be5d" }} />}
                  style={{
                    backgroundColor: "#262626",
                    borderColor: "#404040",
                    color: "#ffffff",
                    borderRadius: "8px",
                  }}
                />
              </Form.Item>

              <Form.Item
                className="mention-font"
                name="phone"
                label={
                  <span className="mention-font" style={{ color: "#ffffff" }}>
                    Phone Number
                  </span>
                }
                rules={[
                  { required: true, message: "Please enter your phone number" },
                ]}
              >
                <Input
                  className="mention-font"
                  placeholder="+995 555 55 55 55"
                  prefix={<PhoneOutlined style={{ color: "#e6be5d" }} />}
                  style={{
                    backgroundColor: "#262626",
                    borderColor: "#404040",
                    color: "#ffffff",
                    borderRadius: "8px",
                  }}
                />
              </Form.Item>

              <Form.Item
                name="message"
                label={<span style={{ color: "#ffffff" }}>Message</span>}
                rules={[
                  { required: true, message: "Please enter your message" },
                ]}
              >
                <TextArea
                  className="mention-font"
                  placeholder="Tell us how we can help you..."
                  rows={5}
                  style={{
                    backgroundColor: "#262626",
                    borderColor: "#404040",
                    color: "#ffffff",
                    borderRadius: "8px",
                    resize: "none",
                  }}
                />
              </Form.Item>

              <Form.Item name="consent" valuePropName="checked">
                <Checkbox
                  className="custom-checkbox"
                  style={{ color: "#999999" }}
                >
                  I'd like to receive more information about Paysphere. I
                  understand and agree to the{" "}
                  <a href="#" style={{ color: "#facc15" }}>
                    Privacy Policy
                  </a>
                  .
                </Checkbox>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    color: "#000",
                    width: "100%",
                    height: "48px",
                    backgroundColor: "#facc15",
                    borderColor: "#facc15",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  Send Message
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Col>
        <Col span={24} style={{ textAlign: "center", marginTop: "2rem" }}>
          <footer className="footer">
            <div className="footer-tagline">Journey Never Stop</div>
            <div className="footer-bottom">
              <div className="footer-logo">
                SETH
                <br />
                White
              </div>
            </div>
          </footer>
        </Col>
      </Row>
    </div>
  );
};

export default ContactUs;
